import template from './device.html'
import {postJson} from '../../helpers'

const pageDevice = () => {
  return {
    root: null,
    title: '',
    device: null,
    path: '',
    refreshFlag: new Date().getTime(),
    async init() {
      console.log('Page device!')
      this.root = this
      this.$nextTick(_ => {
        this.$el.innerHTML = template
      })
      const context = await this.callIOS('getContext')
      console.log(context.path)
      this.path = context.path

      this.device = this.app.context.device
      this.title = this.device.name
    },
    getScheme() {
      if (window.webkit && window.webkit.messageHandlers.IOS == undefined) {
        return 'socket://com.videokot.cctv/app'
      }
      return 'x-local:/'
    },
    goCamera(index) {
      this.app.context.cameraIndex = index
      this.app.context.device = this.device
      this.app.context.path = this.path
      this.app.goPage('camera')
    },
    activating() {
      window._app.callIOS('allowSleepAgain')
      this.refreshFlag = new Date().getTime()
    }
  }
}

export { pageDevice }
